<template>
  <!-- Popup -->
  <div class="about-modal">
    <div class="about-modal__header">
      <img
        src="@graphics/about_header4.png"
        alt="Copyright Header"
      >
    </div>
    <div class="about-modal__body">
      <h1>Software versions</h1>

      <ul
        v-for="information in versionInformation"
        :key="information.name"
        class="about-modal__body__information"
      >
        <li><h2>{{ information.title }}</h2></li>
        <li class="about-modal__body__information__row">
          <strong>Name</strong>
          <div>{{ information.name }}</div>
        </li>
        <li class="about-modal__body__information__row">
          <strong>Version</strong>
          <div>{{ information.version }}</div>
        </li>
        <li
          v-if="information.version2"
          class="about-modal__body__information__row"
        >
          <strong>DB Version</strong>
          <div>{{ information.version2 }}</div>
        </li>
      </ul>
      <hr>
      <div class="disclaimer">
        <h1>Web Site Terms and Conditions of Use</h1>
        <h2 class="size-one-point-two-five">
          <b>In General</b>
        </h2>
        <p>This site is provided to you by S-Rain Control A/S (“SRC”). References to “Site” as used in these Terms and Conditions of Use includes our digital properties and applications on our websites and applications on mobile devices. Access to and use of this Site and the services available at this Site are subject to these Terms and Conditions of Use (the "Terms"). By accessing or using the Site or downloading any materials from the Site, you warrant that you are 18 years of age or older and agree to these Terms. If you do not agree to the Terms, you must immediately log off the Site and may not use the Site.</p>
        <h2 class="size-one-point-two-five">
          <b>Intellectual Property, Limitations on Use</b>
        </h2>
        <p>All content, data, and materials contained on this Site, together with all related rights with respect to registered and unregistered copyrights, registered and unregistered trademarks or service marks, patents, trade secrets, and all other proprietary rights are exclusively owned or licensed by SRC.  All of the foregoing are protected under the laws of Denmark, foreign jurisdictions, and/or international treaties. </p>
        <p>This Site and all related proprietary rights shall remain the exclusive property of SRC or the applicable licensors of content, data, or materials. </p>
        <h2 class="size-one-point-two-five">
          <b>Disclaimer of Warranties and Limitation of Liability</b>
        </h2>
        <p>THIS SITE IS PROVIDED ON AN “AS IS, WITH ALL DEFECTS” AND “AS AVAILABLE” BASIS WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESSED OR IMPLIED, INCLUDING WITHOUT LIMITATION, WARRANTIES OF TITLE, NON-INFRINGEMENT, OR IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE. NOTHING IN THESE TERMS OR IN ANY DESCRIPTION OF PRODUCTS OR SERVICES ON THE SITE SHALL CONSTITUTE A REPRESENTATION OR WARRANTY WITH RESPECT TO SUCH PRODUCTS OR SERVICES. YOU ACKNOWLEDGE, BY YOUR USE OF THIS SITE, THAT SUCH USE IS AT YOUR SOLE RISK. SRC EXPRESSLY DISCLAIMS ANY REPRESENTATIONS AND WARRANTIES THAT (I) THE SITE WILL OPERATE IN AN ERROR FREE OR UNINTERRUPTED MANNER; (II) THE SITE AND THE ONLINE SERVER THAT MAKES THE SITE AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL ELEMENTS; (III) THE SITE WILL SATISFY THE CUSTOMER’S REQUIREMENTS; (IV) THE RESULTS OBTAINED FROM THE USE OF THE SITE WILL BE EFFECTIVE, ACCURATE, OR RELIABLE; (V) SRC WILL PREVENT THE UNAUTHORIZED DISCLOSURE OF, UNAUTHORIZED USE OF, UNAUTHORIZED ACCESS TO, MISAPPROPRIATION OF, LOSS OF, OR ALTERATION OF ANY DATA OR INFORMATION; OR (VI) ANY ERRORS OR DEFECTS IN THE SITE WILL BE CORRECTED. SRC DISCLAIMS ANY REPRESENTATION OR WARRANTY THAT THE USE OF THE SITE WILL SATISFY, OR ENABLE YOU TO SATISFY, THE REQUIREMENTS OF ANY GOVERNMENT AGENCY, ASSOCIATION, OR OTHER ORGANIZATION. NOTHING IN THESE TERMS OR IN ANY ORAL OR WRITTEN DESCRIPTION OF THE SITE SHALL CONSTITUTE A REPRESENTATION OR WARRANTY WITH RESPECT TO THE SITE. SRC IS NOT RESPONSIBLE FOR TYPOGRAPHICAL ERRORS OR OMISSIONS RELATING TO TEXT OR PHOTOGRAPHY. </p>
        <p>IN NO EVENT SHALL SRC BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL OR CONSEQUENTIAL DAMAGES ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OF THIS SITE, WHETHER BASED ON CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE, EVEN IF ADVISED OF THE POSSIBILITY OF ANY SUCH DAMAGES. </p>
        <h2 class="size-one-point-two-five">
          <b>Indemnification</b>
        </h2>
        <p>You agree to indemnify, defend, and hold harmless SRC and its successors and assigns from and against and in respect of any and all third-party claims, demands, losses, costs, expenses, obligations, liabilities, damages, recoveries, and deficiencies, including interest, penalties, and reasonable attorneys' fees that it shall incur or suffer which relate to your use of this Site, your failure to perform any of your obligations under these Terms, or your breach of any of your representations or warranties made under these Terms.</p>
        <h2 class="size-one-point-two-five">
          <b>Changes</b>
        </h2>
        <p>These Terms may be changed without notice. You expressly waive any right to receive notice of any changes to these Terms. Any use of this Site following the date on which changes to these Terms are published shall constitute your acceptance of all such changes. You should review these Terms often to determine whether any changes have been made.</p>
        <h2 class="size-one-point-two-five">
          <b>Operation, Accessibility and Maintenance of this Site</b>
        </h2>
        <p>SRC may modify, change, suspend, terminate, or discontinue the operation of this Site or the provision of any products or services without notice, and reserves the right to refuse service to anyone at any time, with or without cause. </p>
        <h2 class="size-one-point-two-five">
          <b>General Provisions</b>
        </h2>
        <p>Any failure by SRC to enforce any provision of these Terms shall not be construed as a waiver of any provision or the right to enforce same. These Terms shall be governed by the laws of Denmark, without regard to its choice of law principles or rules. For the purpose of resolving conflicts relating to or arising out of these Terms, or arising out of any other dispute or claim associated with the Site, venue shall be in Denmark only and, in addition, you hereby consent to the exclusive jurisdiction of the court in Copenhagen, Denmark. If any portion of these Terms are held to be invalid, such holding shall not invalidate the other provisions of these Terms.</p>
        <p>May 2017</p>
      </div>
    </div>
    <div class="about-modal__footer">
      <div id="footer-content">
        <hr>
        <p>
          This web application uses Node.js libraries covered by<br>
          <a
            href="https://opensource.org/licenses/MIT"
            target="_blank"
          >
            MIT
          </a>,
          <a
            href="https://opensource.org/licenses/BSD-3-Clause"
            target="_blank"
          >
            BSD-3-Clause
          </a>,
          <a
            href="https://opensource.org/licenses/Apache-2.0"
            target="_blank"
          >
            Apache-2.0
          </a>, and
          <a
            href="https://opensource.org/licenses/ISC"
            target="_blank"
          >
            ISC
          </a> licenses.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
/* Mixins */
import {SocketHandler, LifeCycle} from '@/assets/javascript/mixins/Mixins'
/* ------ */
export default {
  name: 'About',
  mixins: [SocketHandler, LifeCycle],
  props:
  {
    store: {
      type: Object,
      default: function() {
        return{}
      }
    },
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
      versionInformation: {
        application: {
          title: 'Client',
          name: 'Client',
          version: this.store.getData('application.versions.client'),
        },
        client: {
          title: 'Client Node',
          name: null,
          version: null,
        },
        server: {
          title: 'Server Node',
          name: null,
          version: null,
        },
        cims: {
          title: 'CIMS',
          name: null,
          version: null,
          version2: null
        }
      }
    }
  },
  watch: {
    SocketMessage(Message) {
      if(Message.data.command === 'version') {
        if(Message.data.data.clientNode) {
          Object.assign(this.versionInformation.client, {
            name: Message.data.data.clientNode.name,
            version: Message.data.data.clientNode.version
          })
        }

        if(Message.data.data.serverNode) {
          Object.assign(this.versionInformation.server, {
            name: Message.data.data.serverNode.name,
            version: Message.data.data.serverNode.version
          })
        }

        if(Message.data.data.CIMS) {
          Object.assign(this.versionInformation.cims, {
            name: Message.data.data.CIMS.name,
            version: Message.data.data.CIMS.ReleaseVersion,
            version2: (Message.data.data.CIMSModule) ? Message.data.data.CIMSModule.DBVersion : null
          })
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .about-modal {
    box-sizing: border-box;
    background: $color-white;
    width: 100vw;
    padding: 20px;
    line-height: 20px;

    &__header {
      img {
        width: 100%;
      }
    }
    &__body {
      h1, h2 {
        margin: 20px 0 5px;
        font-family: $font-primary-semibold;
      }
      &__information {
        width: 100%;
        * {
          word-wrap: break-word;         /* All browsers since IE 5.5+ */
          overflow-wrap: break-word;     /* Renamed property in CSS3 draft spec */
        }
        &__row {
          display: grid;
          grid-template-columns: 30% 50%;
          grid-gap: 10px;
          padding: 5px;

          >*:first-child {
            width: 30%;
            min-width: 150px;
          }

          &:nth-child(odd):not(:first-child) {
            background: lighten($color-grey, 15);
          }
        }
      }

      hr {
        margin: 20px 0;
      }
    }
    &__footer {
    }
  }

  @media screen and (min-width: $bp-mobile) {
    .about-modal {
      width: 85vw;
    }
  }

  @media screen and (min-width: $bp-tablet) {
    .about-modal {
      max-width: $bp-desktop;
    }
  }
</style>
